import { Box, Card, Grid, Typography } from "@mui/material";
import React from "react";

export default function Awards() {
  const cardDetails = [
    {
      num: "1",
      subTittile: "New stores launched last year",
    },
    {
      num: "1 Lakh+",
      subTittile: "Happy customers served",
    },
    {
      num: "500+",
      subTittile: "Products available across categories",
    },
  ];

  return (
    <Box id="awards">
      <Box
        sx={{
          background: "#778A2420",
          my: { lg: "120px", xs: "20px" },
          color: "#101828",
          zIndex: 2,
          position: "relative",
        }}
      >
        <Box
          className="layoutMargin"
          sx={{
            px: { lg: "80px", md: "40px", xs: "20px" }, // ✅ equal left-right padding
            py: { lg: "100px", xs: "40px" },
          }}
        >
          <Grid container spacing={4}>
            {/* LEFT TEXT */}
            <Grid lg={8} xs={12} item sx={{ textAlign: "start" }}>
              <Typography
                variant="h4"   // ✅ use a larger variant (instead of body1)
                className="caveatFont"
                sx={{
                  fontWeight: 600,
                  color: "#778A24",
                }}
              >
                Achievements
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: "56px",
                  textAlign: "start",
                  fontWeight: 500,
                  mt: { lg: "20px", xs: "20px" },
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                Milestones & Recognition
              </Typography>
              <Typography variant="body2" sx={{ margin: "20px 0px" }}>
                Best Retail Experience Award 2021
              </Typography>
              <Typography variant="body2" sx={{ margin: "20px 0px" }}>
                Excellence in Customer Service 2022
              </Typography>
              <Typography variant="body2" sx={{ margin: "20px 0px" }}>
                Green Mall Initiative Recognition
              </Typography>
              <Typography variant="body2" sx={{ margin: "20px 0px" }}>
                Most Popular Shopping Destination 2023
              </Typography>
            </Grid>

            {/* RIGHT CARDS */}
            <Grid lg={4} xs={12} item>
              {cardDetails.map((card, index) => (
                <Card
                  key={index}
                  sx={{
                    p: "20px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "start",
                    // width: "100%",
                    mt: "20px",
                    width: "400px",
                  }}
                >
                  <Box
                    sx={{
                      background: "#778A24",
                      width: "100px",
                      height: "60px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "7px",
                      color: "#fff",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 700,
                        fontSize: "22px",
                        textAlign: "center",
                      }}
                    >
                      {card.num}
                    </Typography>
                  </Box>
                  <Box sx={{ ml: "20px", textAlign: "start" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 400,
                      }}
                    >
                      {card.subTittile}
                    </Typography>
                  </Box>
                </Card>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
